import axios from '@/axios'

const RESOURCE_NAME = '/action-logs';

export default {

    removeActivity(id) {
        return axios.post(`${RESOURCE_NAME}/remove-activity?id=${id}`)
    },

    getActionLogs(data) {
        return axios.post(`${RESOURCE_NAME}/get-action-logs`, data)
    },

    getActionLogsFeed(filter, maxDate) {
        return axios.post(`${RESOURCE_NAME}/get-action-logs-feed`, {filter, maxDate})
    },
}
